import React from 'react';
import Img from '../../../../../components/Img/Img';
import Modal from '../../../../../components/Modal';
import tagTabMainRightArrow from '../../../../../static/images/tag/tagTabMain/tag-tab-main-right-arrow.png';
import TagPreviewMainTabItem from '../../tagPreview/TagPreviewMainTabItem/TagPreviewMainTabItem';
import './PreviewTagTabMainModal.scss';

const PreviewTagTabMainModal = (props) => {
  const { isOpen, closeModal, data } = props;
  const { tagTabMainPreviewData } = data;
  const { tagTrendKeywordList, tagFollowSelectedList } = tagTabMainPreviewData;

  return (
    <Modal
      title={'태그 탭 메인 미리보기'}
      wrapClassName="preview-tag-tab-main-modal-wrapper"
      isOpen={isOpen}
      width={377}
      height={700}
      padding={'0px'}
      isFooter={false}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="preview-tag-tab-main-modal-wrap">
        <div className="following-tag-count-section">
          팔로잉한 태그<span>#47</span>
          <Img className="right-arrow-img" clickAble={false} src={tagTabMainRightArrow} />
        </div>

        <div className="tag-trend-keyword-list-section">
          <div className="tag-trend-keyword-list-title">트렌드 키워드</div>

          <div className="tag-trend-keyword-list">
            {tagTrendKeywordList.map((item) => (
              <div className="tag-trend-keyword-item" key={item.id}>
                <Img className="tag-img" clickAble={false} src={item.url} />
                <div className="tag-name">#{item.name}</div>
              </div>
            ))}

            <div className="view-more">
              <span>더보기</span>
              <Img className="right-arrow-img" clickAble={false} src={tagTabMainRightArrow} />
            </div>
          </div>
        </div>

        <div className="tag-follow-selected-list-section">
          {tagFollowSelectedList.map((tagFollowSelected, index) => (
            <TagPreviewMainTabItem
              key={index}
              tagName={tagFollowSelected.tagInfo.tagName}
              tagViewInfo={tagFollowSelected.tagViewInfo}
              itemContentList={tagFollowSelected.tagMainTab.itemList}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default PreviewTagTabMainModal;
